import { useEffect, useState } from 'react'

export const useGlobalFileDrag = () => {
  const [isDraggingFile, setIsDraggingFile] = useState(false)

  useEffect(() => {
    let dragCounter = 0
    const onDragEnter = (e) => {
      if (e.dataTransfer?.types?.includes('Files')) {
        e.preventDefault()
        dragCounter++
        setIsDraggingFile(true)
      }
    }

    const onDragOver = (e) => {
      if (e.dataTransfer?.types?.includes('Files')) {
        e.preventDefault()
      }
    }

    const onDragLeave = (e) => {
      if (e.dataTransfer?.types?.includes('Files')) {
        dragCounter--
        if (dragCounter <= 0) {
          setIsDraggingFile(false)
          dragCounter = 0
        }
      }
    }

    const onDrop = (e) => {
      if (e.dataTransfer?.types?.includes('Files')) {
        e.preventDefault()
        e.stopPropagation()
      }
      dragCounter = 0
      setIsDraggingFile(false)
    }

    window.addEventListener('dragenter', onDragEnter)
    window.addEventListener('dragover', onDragOver)
    window.addEventListener('dragleave', onDragLeave)
    window.addEventListener('drop', onDrop)

    return () => {
      window.removeEventListener('dragenter', onDragEnter)
      window.removeEventListener('dragover', onDragOver)
      window.removeEventListener('dragleave', onDragLeave)
      window.removeEventListener('drop', onDrop)
    }
  }, [])

  return { isDraggingFile }
}
